export default __webpack_public_path__ + "static/media/konec.174f88ab.png";